module.exports = __webpack_public_path__ + "img/home_title11.e9acfe03.png";